import ProjectTypeBadge, { ProjectType } from "components/ProjectTypeBadge";
import TableSimpleCell from "ds/components/TableSimple/Cell";

import styles from "./styles.module.css";
import { IntegrationsAwsUsedByTableCellProps } from "./types";

const IntegrationsAwsUsedByTableTypeCell = ({
  item,
  ...cellProps
}: IntegrationsAwsUsedByTableCellProps) => {
  return (
    <TableSimpleCell {...cellProps}>
      <ProjectTypeBadge
        className={styles.typeCell}
        projectType={item.isModule ? ProjectType.Module : ProjectType.Stack}
      />
    </TableSimpleCell>
  );
};

export default IntegrationsAwsUsedByTableTypeCell;
